import { appendIconComponentCache } from "@elastic/eui/es/components/icon/icon";
import { icon as check } from "@elastic/eui/es/components/icon/assets/check";
import { icon as checkCircle } from "@elastic/eui/es/components/icon/assets/checkCircle";
import { icon as checkInCircleFilled } from "@elastic/eui/es/components/icon/assets/checkInCircleFilled";
import { icon as cross } from "@elastic/eui/es/components/icon/assets/cross";
import { icon as crossInCircle } from "@elastic/eui/es/components/icon/assets/crossInCircle";
import { icon as copy } from "@elastic/eui/es/components/icon/assets/copy";
import { icon as save } from "@elastic/eui/es/components/icon/assets/save";
import { icon as trash } from "@elastic/eui/es/components/icon/assets/trash";

import { icon as arrow_down } from "@elastic/eui/es/components/icon/assets/arrow_down";
import { icon as arrow_left } from "@elastic/eui/es/components/icon/assets/arrow_left";
import { icon as arrow_right } from "@elastic/eui/es/components/icon/assets/arrow_right";
import { icon as arrow_up } from "@elastic/eui/es/components/icon/assets/arrow_up";
import { icon as sort_down } from "@elastic/eui/es/components/icon/assets/sort_down";
import { icon as sort_up } from "@elastic/eui/es/components/icon/assets/sort_up";

import { icon as calendar } from "@elastic/eui/es/components/icon/assets/calendar";
import { icon as clock } from "@elastic/eui/es/components/icon/assets/clock";
import { icon as code } from "@elastic/eui/es/components/icon/assets/code";
import { icon as comment } from "@elastic/eui/es/components/icon/assets/comment";
import { icon as dot } from "@elastic/eui/es/components/icon/assets/dot";
import { icon as dotInCircle } from "@elastic/eui/es/components/icon/assets/dotInCircle";
import { icon as empty } from "@elastic/eui/es/components/icon/assets/empty";
import { icon as eye } from "@elastic/eui/es/components/icon/assets/eye";
import { icon as eye_closed } from "@elastic/eui/es/components/icon/assets/eye_closed";
import { icon as link } from "@elastic/eui/es/components/icon/assets/link";
import { icon as list } from "@elastic/eui/es/components/icon/assets/list";
import { icon as list_add } from "@elastic/eui/es/components/icon/assets/list_add";
import { icon as minus } from "@elastic/eui/es/components/icon/assets/minus";
import { icon as pencil } from "@elastic/eui/es/components/icon/assets/pencil";
import { icon as plus } from "@elastic/eui/es/components/icon/assets/plus";
import { icon as quote } from "@elastic/eui/es/components/icon/assets/quote";
import { icon as refresh } from "@elastic/eui/es/components/icon/assets/refresh";
import { icon as search } from "@elastic/eui/es/components/icon/assets/search";
import { icon as unlink } from "@elastic/eui/es/components/icon/assets/unlink";

import { icon as editor_align_center } from "@elastic/eui/es/components/icon/assets/editor_align_center";
import { icon as editor_align_left } from "@elastic/eui/es/components/icon/assets/editor_align_left";
import { icon as editor_align_right } from "@elastic/eui/es/components/icon/assets/editor_align_right";
import { icon as editor_bold } from "@elastic/eui/es/components/icon/assets/editor_bold";
import { icon as editor_checklist } from "@elastic/eui/es/components/icon/assets/editor_checklist";
import { icon as editor_heading } from "@elastic/eui/es/components/icon/assets/editor_heading";
import { icon as editor_italic } from "@elastic/eui/es/components/icon/assets/editor_italic";
import { icon as editor_link } from "@elastic/eui/es/components/icon/assets/editor_link";
import { icon as editor_ordered_list } from "@elastic/eui/es/components/icon/assets/editor_ordered_list";
import { icon as editor_redo } from "@elastic/eui/es/components/icon/assets/editor_redo";
import { icon as editor_strike } from "@elastic/eui/es/components/icon/assets/editor_strike";
import { icon as editor_table } from "@elastic/eui/es/components/icon/assets/editor_table";
import { icon as editor_underline } from "@elastic/eui/es/components/icon/assets/editor_underline";
import { icon as editor_undo } from "@elastic/eui/es/components/icon/assets/editor_undo";
import { icon as editor_unordered_list } from "@elastic/eui/es/components/icon/assets/editor_unordered_list";

appendIconComponentCache({
  check,
  checkCircle,
  checkInCircleFilled,
  cross,
  crossInCircle,
  copy,
  save,
  trash,

  arrowDown: arrow_down,
  arrowLeft: arrow_left,
  arrowRight: arrow_right,
  arrowUp: arrow_up,
  arrow_down,
  arrow_left,
  arrow_right,
  arrow_up,
  sortDown: sort_down,
  sortUp: sort_up,
  sort_down,
  sort_up,

  calendar,
  clock,
  code,
  comment,
  dot,
  dotInCircle,
  empty,
  eye,
  eyeClosed: eye_closed,
  eye_closed,
  link,
  list,
  listAdd: list_add,
  list_add,
  minus,
  pencil,
  plus,
  quote,
  refresh,
  search,
  unlink,

  editorAlignCenter: editor_align_center,
  editor_align_center,
  editorAlignLeft: editor_align_left,
  editor_align_left,
  editorAlignRight: editor_align_right,
  editor_align_right,
  editorBold: editor_bold,
  editor_bold,
  editorChecklist: editor_checklist,
  editor_checklist,
  editorHeading: editor_heading,
  editor_heading,
  editorItalic: editor_italic,
  editor_italic,
  editorLink: editor_link,
  editor_link,
  editorCodeBlock: code,
  editor_code_block: code,
  editorComment: comment,
  editorOrderedList: editor_ordered_list,
  editor_ordered_list,
  editorRedo: editor_redo,
  editor_redo,
  editorStrike: editor_strike,
  editor_strike,
  editorTable: editor_table,
  editor_table,
  editorUnderline: editor_underline,
  editor_underline,
  editorUndo: editor_undo,
  editor_undo,
  editorUnorderedList: editor_unordered_list,
  editor_unordered_list,

  // Explicit bundle path keys that EUI tries to load dynamically
  "./assets/dot": dot,
  "./assets/empty": empty,
});
